/** A page of an old build can ask for a file that the new release removed; one reload gets the new build. */
export const CHUNK_KEY = "xflow-chunk-reload";
export const CHUNK_GAP_MS = 5 * 60_000;

const CHUNK_TEXT = /dynamically imported module|Importing a module script failed|ChunkLoadError|Loading chunk [\w-]+ failed|Unable to preload CSS/i;

export function isChunkError(error: unknown): boolean {
  const text = error instanceof Error ? `${error.name} ${error.message}` : String(error ?? "");
  return CHUNK_TEXT.test(text);
}

interface Deps {
  storage: () => Pick<Storage, "getItem" | "setItem"> | undefined;
  now: () => number;
  reload: () => void;
}

const DEFAULTS: Deps = { storage: () => sessionStorage, now: Date.now, reload: () => location.reload() };

/** Reload one time; a second error in CHUNK_GAP_MS shows the error, so the page never loops. */
export function reloadOnce(deps: Deps = DEFAULTS): boolean {
  let storage: ReturnType<Deps["storage"]>;
  try {
    storage = deps.storage();
  } catch {
    return false;
  }
  const last = Number(storage?.getItem(CHUNK_KEY) ?? 0);
  if (!storage || deps.now() - last < CHUNK_GAP_MS) return false;
  try {
    storage.setItem(CHUNK_KEY, String(deps.now()));
  } catch {
    return false;
  }
  deps.reload();
  return true;
}
